// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__qnXsJ","iconChecker":"icon_iconChecker__qpzpx","iconCursor":"icon_iconCursor__rmQ21"};